// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cy","header":"cz","subHeader":"cA","button":"cB","actionLinks":"cC","actionLink":"cD","actionText":"cE"};